import { qrMenuGET } from 'featureSliced/shared/api/qrMenu/GET'
import { SpecialsSlice } from '.'
import { AppDispatch } from '../../index'
import { initialState } from './types'

export const getSpecialPrices = () => async (dispatch: AppDispatch) => {
  try {
    const result: any[] = await qrMenuGET.getSpecials()
    dispatch(
      SpecialsSlice.actions.setSpecials({
        isSpecialsLoaded: true,
        discounts: result?.[0]?.discounts,
        individualPrices: result?.[1]?.individualPrices,
        productListWithPrices: result?.[2]?.productListWithPrices,
        offerPrices: result?.[3]?.offerPrices ?? [],
      })
    )
  } catch (e) {
    // Pricing extras must never block the menu: the spinner waits on isSpecialsLoaded
    // and this thunk runs inside the loadMenuData Promise.all.
    dispatch(
      SpecialsSlice.actions.setSpecials({
        ...initialState,
        isSpecialsLoaded: true,
      })
    )
  }
}
